import { useMemo } from 'react';
import { UAParser } from 'ua-parser-js';
import { useUserAgent } from '@/context/UserAgent';

export const useOSDetect = (): string => {
  const userAgent = useUserAgent();

  return useMemo((): string => {
    let parser: UAParser;
    if (typeof userAgent === 'undefined') {
      try {
        parser = new UAParser(navigator.userAgent);
      } catch {
        return 'unidentified';
      }
    } else {
      parser = new UAParser(userAgent);
    }
    const os = parser.getOS();
    return os.name || 'unidentified';
  }, [userAgent]);
};
